var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.246 0L482.493 127.979V384.021L256.246 512L30 384.021V127.979L256.246 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.113 375.142L263.762 476.142V397.596L374.922 336.381L442.113 375.142ZM454.321 364.128V153.079L389.094 190.73V326.477L454.321 364.128ZM69.7024 375.142L248.053 476.056V397.51L136.893 336.381L69.7024 375.142ZM57.4937 364.128V153.079L122.721 190.73V326.477L57.4937 364.128ZM65.0921 139.419L248.053 35.9429V111.928L130.832 176.386L129.893 176.899L65.0921 139.419ZM446.638 139.419L263.762 35.9429V111.928L380.898 176.472L381.837 176.984L446.638 139.419Z",
    fill: "#8ED6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.051 379.667L138.428 319.306V199.865L248.051 263.129V379.667ZM263.76 379.667L373.383 319.392V199.865L263.76 263.129V379.667ZM145.771 186.035L255.906 125.503L365.955 186.035L255.906 249.554L145.771 186.035Z",
    fill: "#1C78C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpack);
export default __webpack_public_path__ + "static/media/Webpack.edd03c58d49eb84d63d77dad65ced3b9.svg";
export { ForwardRef as ReactComponent };